import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  Stack,
  Button,
  IconButton,
} from '@mui/material';

const features = [
  { key: 'departments', label: 'Departments' },
  { key: 'analytics', label: 'Advanced analytics' },
  { key: 'livetyping', label: 'Live typing' },
  { key: 'visitors', label: 'Visitors info' },
  { key: 'shopify', label: 'Native Shopify actions' },
  { key: 'live_list', label: 'Live visitor list' },
];

export default function OnboardingTrial() {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: 'rgba(0,0,0,0.4)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Container maxWidth="md" disableGutters>
        <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
          {/* Header hero */}
          <Box sx={{ position: 'relative', height: 180, bgcolor: 'grey.100' }}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1556157382-97eda2d62296?q=80&w=1600&auto=format&fit=crop"
              alt="Trial hero"
              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <IconButton
              aria-label="close"
              onClick={() => navigate('/chat')}
              sx={{ position: 'absolute', right: 8, top: 8, bgcolor: 'background.paper' }}
            >
              ✕
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Your 7-day full-featured trial starts now
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Welcome to your trial where you can test our premium features to determine the best plan for you. Your features include:
            </Typography>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              {features.map((f) => (
                <Grid key={f.key} item xs={12} md={6}>
                  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
                      <Stack direction="row" spacing={1.5} alignItems="center">
                        <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: 'grey.100', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🔹</Box>
                        <Typography variant="body2">{f.label}</Typography>
                      </Stack>
                      <Box sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: 'primary.main', color: 'primary.contrastText', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✓</Box>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>

            <Stack direction="row" justifyContent="flex-end">
              <Button variant="contained" onClick={() => navigate('/chat')}>Let’s go</Button>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}





